// extracted by mini-css-extract-plugin
export var infoItem = "_m4-1";
export var title = "_m4-0";